import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";

import Select from "react-select";

import { useDispatch, useSelector } from "react-redux";
import { convertList, reportListConverter } from "../../Utils";
import { useNavigate } from "react-router-dom";
import {
  resetReportDetailStatus,
  setIsSavedReport,
  setRunNewReport,
} from "../../store/reducers/reportDocumentSlice";
import CustomBreadCrumbs from "../../components/CustomBreadCrumbs";
import { fetchReportList } from "../../store/reducers/reportDocumentSlice/api";
import { useAbortController } from "../../hooks/useAbortController";

const RunNewReport1 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const chooseReportLabelListRND = reportListConverter(
  //   useSelector((state) => state.RS_Authentication.reportList)
  // );

  const reportList = convertList(
    useSelector((state) => state.reportDocument.reportList.data)
  );
  const { signal } = useAbortController();

  const reportListStatus = useSelector(
    (state) => state.reportDocument.reportList.status
  );

  // if (chooseReportLabelListRND?.length) {
  //   chooseReportLabelListRND?.unshift({
  //     label: "Create Report Request",
  //     value: "Create Report Request",
  //   });
  // }
  // if (reportList?.length) {
  //   reportList?.unshift({
  //     label: "Create Report Request",
  //     value: "Create Report Request",
  //   });
  // }

  const [selectSPApi, setSelectSPApi] = useState(null);

  useEffect(() => {
    // if (reportListStatus === "idle") {
    dispatch(fetchReportList({ signal }));
    dispatch(setIsSavedReport(false));
    dispatch(resetReportDetailStatus());
    // }
  }, [dispatch]);

  const handleRun = async () => {
    if (selectSPApi?.value) {
      navigate(selectSPApi?.value);
    }
  };
  const handleReportChange = (e) => {
    if (e?.value) {
      // if (e.value === "Create Report Request") {
      //   navigate("/create-new-report");
      // }
      // const options =
      //   reportList?.filter((data) => data.value === e.value)?.[0]
      //     ?.options || [];
      setSelectSPApi(e);
      // dispatch(
      //   setRunNewReport({ report: e, reportName: e.label, options: options })
      // );
      dispatch(setRunNewReport({ report: e, reportName: e.label }));
    } else if (e?.label === "Create Report Request") {
      navigate("/create-new-report");
    } else if (e?.label === "My Scheduled Reports") {
      navigate("/reports-and-documents");
    } else {
      setSelectSPApi(null);
    }
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eee", minHeight: "92vh" }}
      >
        <CustomBreadCrumbs
          crumbs={[
            { title: "Reports & Documents", link: "/reports-and-documents" },
            { title: "Run New Report", link: "" },
          ]}
        />
        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <div className="col-sm-6">
              <Form.Label className="mt-5">Choose Report</Form.Label>
              <Select
                options={reportList?.map(({ value, label, report_id }) => ({
                  value,
                  label,
                  report_id,
                }))}
                value={selectSPApi ? selectSPApi : null}
                onChange={handleReportChange}
                classNamePrefix="select"
                isLoading={
                  reportListStatus === "loading" || reportListStatus === "idle"
                }
                loadingMessage={() => "Loading options..."}
              />
            </div>
            <Button
              className="mt-5 btn btn-primary text-white btn-outline py-3 px-4 me-3"
              onClick={handleRun}
            >
              Run
            </Button>
          </section>
        </article>
      </section>
    </div>
  );
};

export default RunNewReport1;
